<template>
    <div>
        <div class="tool-bar">
            <span class="total-num">共{{searchData.allcount}}条记录   第{{searchData.pageNum}}/{{allPage()}}页</span>
            <Page class="toolbar"
                :total="searchData.allcount"
                show-elevator
                show-sizer
                size="small"
                :page-size="searchData.pageSize"
                :current.sync="searchData.pageNum"
                :page-size-opts="page.pagesizes"
                @on-change="handleCurrentChange"
                @on-page-size-change="handleSizeChange">
            </Page>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        url: String,
        searchData: Object,
        params:String,
        from: String,
        isget: {
            type: Boolean,
            default: true
        },
        apifrom: String,
        code: String
    },
    data() {
        return {
            // 分页
            page: {
                currentPage: 1,
                lastPage: 0,
                pagesizes: [10, 15, 20, 25],
                allcount: 0
            },
            tableData: [],
        }
    },
    methods: {
        getData() {
            for(var val in this.searchData) {
                if ((typeof this.searchData[val]) == 'string') {
                    this.searchData[val] = this.searchData[val].replace(/\s+/g,"");
                    if(!this.searchData[val]&&val!='allcount'){
                        delete(this.searchData[val]);
                    }
                }
            }
            if (this.from == 'taskDetail') {
                // this.request(this.url, this.searchData, true, this.params+'/detail').then((res) => {
                //     if(res.content.meta.pageNum==null||res.content.meta.pageNum==""){
                //         res.content.meta.pageNum=1
                //     }
                //     if(res.content.meta.pageSize==null||res.content.meta.pageSize==""){
                //         res.content.meta.pageSize=10
                //     }
                //     if(res.content.meta.total==null||res.content.meta.total==""){
                //         res.content.meta.total=0
                //     }
                //     this.tableData= res.content.data.task_detail;
                //     this.sequence();
                //     this.searchData.allcount = res.content.meta.total;
                //     this.$emit('ievent', this.tableData);
                // })
            } else if(this.apifrom == 'apidata1') {
                // this.request(this.url, {code:this.code,parameter:this.searchData}, true).then((res) => {
                //     if(res.content.pageInfo.pageNum==null||res.content.pageInfo.pageNum==""){
                //         res.pageInfo.pageNum=1
                //     }
                //     if(res.content.pageInfo.pageSize==null||res.content.pageInfo.pageSize==""){
                //         res.content.pageInfo.pageSize=10
                //     }
                //     if(res.content.pageInfo.total==null||res.content.pageInfo.total==""){
                //         res.content.pageInfo.total=0
                //     }
                //     this.tableData= res.content.list;
                //     this.sequence();
                //     this.searchData.allcount = res.content.pageInfo.total;
                //     this.$emit('ievent', this.tableData);
                // })
            }  else if(this.apifrom == 'apidata2') {
                // this.request(this.url, {code:this.code,parameter:this.searchData}, true).then((res) => {
                //     if(res.content.pageInfo.pageNum==null||res.content.pageInfo.pageNum==""){
                //         res.pageInfo.pageNum=1
                //     }
                //     if(res.content.pageInfo.pageSize==null||res.content.pageInfo.pageSize==""){
                //         res.content.pageInfo.pageSize=10
                //     }
                //     if(res.content.pageInfo.total==null||res.content.pageInfo.total==""){
                //         res.content.pageInfo.total=0
                //     }
                //     this.tableData= res.content.data;
                //     this.sequence();
                //     this.searchData.allcount = res.content.pageInfo.total;
                //     this.$emit('ievent', this.tableData);
                // })
            } else if(this.from == 'mileReport') {
                this.$emit('search', this.searchData);
            } else if(this.from == 'search') {
                this.$emit('search', this.searchData.pageNum);
            } else if (this.from == 'editTable'){
                this.$emit('editSearch', this.searchData.pageNum);
            } else {
                // this.request(this.url, this.searchData, true).then((res) => {
                //     if(res.content.meta.pageNum==null||res.content.meta.pageNum==""){
                //         res.content.meta.pageNum=1
                //     }
                //     if(res.content.meta.pageSize==null||res.content.meta.pageSize==""){
                //         res.content.meta.pageSize=10
                //     }
                //     if(res.content.meta.total==null||res.content.meta.total==""){
                //         res.content.meta.total=0
                //     }
                //     this.tableData= res.content.data;
                //     this.sequence();
                //     this.searchData.allcount = res.content.meta.total;
                //     this.$emit('ievent', this.tableData);
                // })
            }
        },
        // 切换每页条数
        handleSizeChange(val) {
            this.searchData.pageSize = val;
            this.getData();
        },
        // 切换当前页
        handleCurrentChange(val) {
            this.searchData.pageNum = val;
            this.getData();
        },
        //分页列表序号
        sequence() {
            var numtan = (this.searchData.pageNum - 1) * this.searchData.pageSize;
            for (var i = 0; i < this.tableData.length; i++) {
                this.tableData[i].indexsequence = numtan + 1 + i;
            }
        },
        allPage() {
            if(this.searchData.allcount%this.searchData.pageSize == 0){
                if(parseInt(this.searchData.allcount/this.searchData.pageSize) == 0){
                return 1
              }else{
                return parseInt(this.searchData.allcount/this.searchData.pageSize);
              }
            } else {
                return parseInt(this.searchData.allcount/this.searchData.pageSize)+1;
            }
        }
    },
    mounted() {
        if(this.from != 'taskDetail'&&this.isget){
            this.getData();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/main-components/pages.vue